// angular
// 	.module("HeroPRO")
// 	.controller("RemoveOfficeAssignmentController", removeofficeAssignmentController);


import _ from 'lodash';
import './removeOfficeAssignment.scss';

/* @ngInject */
export default function removeofficeAssignmentController($uibModalInstance, selectedOffice, contractorUserId, JobFactory, AccountsFactory) {
    const vm = this;
    vm.contentShown = 'reassignJobs';
    vm.selectedOffice = selectedOffice;
    vm.newUser = null;
    vm.successData = [];

    init();

    /*= =======================================
	=            Public Functions            =
	======================================== */
    vm.closeModal = function () {
        let result = false;

        if (vm.contentShown === 'reassignSuccess') {
            result = true;
        }

	 	$uibModalInstance.close(result);
	 };

    vm.transferToUser = function (user) {
        vm.newUser = user;
        vm.successData.push([`${vm.newUser.FirstName} ${vm.newUser.LastName}`, vm.selectedOffice.LocationNickname]);
    };

    vm.reassignJobsAndRemoveOffice = function () {
        AccountsFactory.reassignJobsAndRemoveOffice(vm.selectedOffice, vm.currentUser, vm.newUser).then(() => {
            vm.contentShown = 'reassignSuccess';
        });
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
	=            Private Functions           =
	======================================== */
    function init() {
        getCurrentUser();
    }

    function getCurrentUser() {
        AccountsFactory.getContractorUser(contractorUserId).then((response) => {
            vm.currentUser = response.data.Data;
            getAvailableUsers();
        });
    }

    function getAvailableUsers() {
        JobFactory.getSalesReps(vm.selectedOffice.ContractorId).then((result) => {
            const users = result.data.Data;
            vm.selectedOffice.users = _.filter(users, user => user.ContractorUserId !== vm.currentUser.ContractorUserId);
        });
    }
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/accounts/user/officeAssignments/removeOfficeAssignmentController.js